import { SVGAttributes } from 'react';

import clsx from 'clsx';
import { nanoid } from 'nanoid';

export const NavGithubLogo = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg aria-hidden='true' {...props} viewBox='0 0 98 96' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z'
        fill='#fff'
      />
    </svg>
  );
};

export const CommunityNavGithubLogo = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
      viewBox='0 0 32 32'
      fill='none'
    >
      <path
        d='M16.0128 0.5C7.43463 0.5 0.5 7.60414 0.5 16.3929C0.5 23.4183 4.94326 29.3651 11.1072 31.4698C11.8779 31.6281 12.1602 31.1279 12.1602 30.7071C12.1602 30.3387 12.1348 29.0757 12.1348 27.7599C7.81948 28.7073 6.92086 25.8653 6.92086 25.8653C6.22737 24.0234 5.19983 23.55 5.19983 23.55C3.78743 22.5764 5.30271 22.5764 5.30271 22.5764C6.86942 22.6817 7.69152 24.2078 7.69152 24.2078C9.07819 26.6284 11.3127 25.9444 12.2116 25.5234C12.3399 24.4971 12.7511 23.7867 13.1877 23.3921C9.74597 23.0237 6.1248 21.6555 6.1248 15.5508C6.1248 13.8141 6.74082 12.3933 7.71692 11.2883C7.56292 10.8937 7.02343 9.26198 7.87124 7.07811C7.87124 7.07811 9.18107 6.65703 12.1345 8.70948C13.3989 8.36159 14.7029 8.18461 16.0128 8.18312C17.3227 8.18312 18.6579 8.36751 19.8909 8.70948C22.8446 6.65703 24.1544 7.07811 24.1544 7.07811C25.0022 9.26198 24.4624 10.8937 24.3084 11.2883C25.3102 12.3933 25.9008 13.8141 25.9008 15.5508C25.9008 21.6555 22.2797 22.9972 18.8122 23.3921C19.3774 23.892 19.8652 24.8391 19.8652 26.339C19.8652 28.4703 19.8397 30.1808 19.8397 30.7068C19.8397 31.1279 20.1224 31.6281 20.8927 31.4702C27.0567 29.3648 31.4999 23.4183 31.4999 16.3929C31.5253 7.60414 24.5653 0.5 16.0128 0.5Z'
        fill='url(#paint0_linear_7870_1291)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_7870_1291'
          x1='0.5'
          y1='16'
          x2='31.5'
          y2='16'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#493DB5' />
          <stop offset='1' stopColor='#6DABD4' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const MenuIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 24 24'
      fill='none'
      strokeWidth='2'
      strokeLinecap='round'
      {...props}
    >
      <path d='M4 7h16M4 12h16M4 17h16' />
    </svg>
  );
};

export const CloseIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 24 24'
      fill='none'
      strokeWidth='2'
      strokeLinecap='round'
      {...props}
    >
      <path d='M5 5l14 14M19 5l-14 14' />
    </svg>
  );
};

// Currently unused: no pages or components render Logomark.
export function Logomark(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 43 43'
      className='h-[30px] w-[30px] fill-brand-light dark:fill-white'
      xmlns='http://www.w3.org/2000/svg'
      aria-label='company logo'
      {...props}
    >
      <path d='M21.0199 42.0398C15.4451 42.0398 10.0986 39.8252 6.15658 35.8832C2.21459 31.9412 0 26.5947 0 21.0199C0 15.4451 2.21459 10.0986 6.15658 6.15658C10.0986 2.21459 15.4451 0 21.0199 0C22.662 0.00186057 24.2985 0.193717 25.8965 0.571741C26.4785 0.709997 26.9818 1.07379 27.2956 1.5831C27.6093 2.0924 27.708 2.7055 27.5697 3.28751C27.4314 3.86952 27.0676 4.37278 26.5583 4.68656C26.049 5.00034 25.4359 5.09895 24.8539 4.9607C21.3554 4.12557 17.6799 4.45554 14.3861 5.90043C11.0923 7.34532 8.36035 9.82612 6.60545 12.9657C4.85056 16.1054 4.16873 19.7321 4.66361 23.2947C5.15849 26.8573 6.803 30.1608 9.34719 32.7033C11.8914 35.2457 15.1961 36.888 18.759 37.3804C22.3219 37.8728 25.9482 37.1885 29.0866 35.4314C32.225 33.6744 34.7039 30.9407 36.1466 27.6459C37.5892 24.3511 37.9166 20.6754 37.0791 17.1775C37.0106 16.8893 36.9996 16.5904 37.0466 16.298C37.0937 16.0055 37.1979 15.7252 37.3532 15.473C37.667 14.9637 38.1703 14.5999 38.7523 14.4617C39.3343 14.3234 39.9474 14.422 40.4567 14.7358C40.966 15.0496 41.3298 15.5529 41.468 16.1349C41.8461 17.7358 42.0379 19.375 42.0398 21.0199C42.0398 26.5947 39.8252 31.9412 35.8832 35.8832C31.9412 39.8252 26.5947 42.0398 21.0199 42.0398Z' />
      <path d='M36.3898 5.64108C35.7596 5.01468 34.9072 4.66309 34.0187 4.66309C33.1302 4.66309 32.2778 5.01468 31.6477 5.64108C31.6218 5.67378 31.5937 5.70468 31.5636 5.73356C31.057 6.28269 30.7439 6.98254 30.6724 7.72625V7.72625C30.6724 7.84396 30.6724 7.96167 30.6724 8.08779C30.6724 8.21391 30.6724 8.24754 30.6724 8.33162C30.5885 9.18186 30.3238 10.0044 29.8961 10.744C29.4684 11.4836 28.8876 12.1232 28.1925 12.6201C27.4974 13.1169 26.7042 13.4594 25.866 13.6246C25.0277 13.7899 24.1638 13.774 23.3322 13.5782L22.8446 13.4521C22.2093 13.2955 21.5565 13.2221 20.9023 13.2335C18.9877 13.2619 17.1514 13.9988 15.7482 15.3018L15.5128 15.512C14.0533 16.9715 13.2334 18.951 13.2334 21.015C13.2334 23.0791 14.0533 25.0585 15.5128 26.518C16.9723 27.9775 18.9518 28.7975 21.0158 28.7975C23.0799 28.7975 25.0593 27.9775 26.5188 26.518C26.8287 26.1894 27.11 25.835 27.3596 25.4586C27.9941 24.5616 28.4314 23.5404 28.643 22.4623C28.8546 21.3841 28.8356 20.2734 28.5872 19.2031C28.5402 19.0653 28.5009 18.9249 28.4695 18.7827C28.4695 18.7827 28.4695 18.7407 28.4695 18.7155C28.2746 17.8767 28.2626 17.0058 28.4344 16.1621C28.6063 15.3183 28.9579 14.5215 29.4653 13.8258C29.9727 13.1301 30.624 12.5518 31.3749 12.1304C32.1259 11.709 32.9588 11.4543 33.8169 11.3837H33.9515H34.3635C35.1386 11.3087 35.8637 10.9669 36.415 10.4168C36.5423 10.2791 36.6603 10.133 36.7681 9.97958C37.2299 9.32904 37.4453 8.53555 37.376 7.74082C37.3067 6.94609 36.9571 6.20187 36.3898 5.64108V5.64108Z' />
    </svg>
  );
}

export function Logo(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 169 43'
      xmlns='http://www.w3.org/2000/svg'
      className='h-[40px] w-[140px] fill-brand-light dark:fill-white -md:w-[100px]'
      aria-label='Gleec logo'
      {...props}
    >
      <path d='m 69.389655,18.498901 h -5.448616 v 3.632373 h 6.338546 v 1.816149 c -0.0031,0.383435 -0.104597,0.759665 -0.294866,1.092584 -0.190272,0.332836 -0.462935,0.611259 -0.791788,0.808402 -0.905361,0.533196 -1.93692,0.814332 -2.987639,0.814332 -1.050712,0 -2.082278,-0.281136 -2.98764,-0.814332 -0.33114,-0.194684 -0.605579,-0.472515 -0.796193,-0.805944 -0.190613,-0.333428 -0.290793,-0.710932 -0.290538,-1.095042 v -7.258736 c 0.0016,-0.384027 0.102968,-0.761105 0.293337,-1.09462 0.190358,-0.333601 0.463696,-0.612362 0.793394,-0.809333 0.911046,-0.519553 1.93896,-0.79967 2.98764,-0.814248 1.050293,0.0029 2.081091,0.283849 2.987639,0.814248 0.330885,0.195615 0.605154,0.474126 0.79569,0.807975 0.190527,0.333855 0.290793,0.71161 0.290964,1.095978 h 3.632379 c 0.0078,-1.002999 -0.247663,-1.990572 -0.739919,-2.864657 -0.492178,-0.874004 -1.20446,-1.604087 -2.066094,-2.117706 -1.476868,-0.887308 -3.167233,-1.356008 -4.890067,-1.356008 -1.72291,0 -3.413275,0.4687 -4.890144,1.356008 -0.861625,0.513619 -1.573831,1.243702 -2.066093,2.117706 -0.492264,0.874085 -0.747294,1.861658 -0.739919,2.864657 v 7.243649 c -0.007,1.002573 0.2485,1.98947 0.740686,2.862963 0.49217,0.873407 1.204204,1.602985 2.065326,2.116432 1.476187,0.889174 3.166807,1.358977 4.890144,1.358977 1.72326,0 3.413881,-0.469803 4.890067,-1.358977 0.861122,-0.513447 1.573156,-1.243025 2.065334,-2.116432 0.492256,-0.873493 0.747542,-1.86039 0.740679,-2.862963 v -5.448609 h -4.522309 z' />
      <path d='m 148.621,23.932249 c -0.003,0.383438 -0.10422,0.759668 -0.29495,1.092588 -0.18987,0.332836 -0.46277,0.611259 -0.79162,0.808398 -0.91113,0.519553 -1.93921,0.79967 -2.98764,0.814247 -1.05013,-0.0029 -2.08076,-0.28376 -2.98764,-0.814247 -0.3314,-0.194681 -0.60516,-0.472511 -0.79587,-0.80594 -0.19069,-0.333428 -0.29071,-0.710932 -0.29071,-1.095046 v -7.243562 c 0.001,-0.384027 0.10251,-0.761105 0.29326,-1.09462 0.1907,-0.333601 0.46362,-0.612362 0.79332,-0.809333 0.91112,-0.519553 1.9392,-0.79967 2.98764,-0.814248 1.05012,0.0029 2.08075,0.283761 2.98764,0.814248 0.33053,0.195615 0.60515,0.474126 0.79584,0.807975 0.19071,0.333855 0.29073,0.71161 0.29073,1.095978 v 1.816233 h 3.63262 v -2.270268 c -0.0635,-0.928332 -0.35259,-1.827167 -0.84163,-2.618444 -0.48988,-0.791279 -1.16538,-1.451103 -1.96717,-1.922003 -1.47729,-0.887309 -3.16732,-1.356008 -4.89041,-1.356008 -1.72309,0 -3.41311,0.468699 -4.8904,1.356008 -0.86112,0.513618 -1.57391,1.243701 -2.0655,2.117705 -0.49243,0.874086 -0.74754,1.861659 -0.73992,2.864657 v 7.255682 c -0.007,1.002577 0.24834,1.989557 0.73992,2.862964 0.49244,0.873493 1.20438,1.603071 2.0655,2.116518 1.47643,0.889091 3.16731,1.358977 4.8904,1.358977 1.72309,0 3.41397,-0.469886 4.89041,-1.358977 0.79416,-0.479884 1.46373,-1.141913 1.95192,-1.931412 0.48819,-0.789497 0.7823,-1.683757 0.85688,-2.609118 V 22.119155 H 148.621 Z' />
      <path d='m 83.422742,10.801217 h -3.632376 v 17.205412 c 0,0.481663 0.19138,0.943669 0.532005,1.284217 0.340554,0.340633 0.802564,0.531928 1.284224,0.531928 h 11.772308 v -3.632377 h -9.956161 z' />
      <path d='m 98.81769,12.611343 v 15.395286 c 0,0.481663 0.19154,0.943669 0.53225,1.284217 0.34073,0.340633 0.80265,0.532011 1.28407,0.532011 h 11.77256 V 26.19048 h -9.97406 v -4.071325 h 8.173 v -3.632373 h -8.173 v -4.062257 h 9.95881 v -3.632376 h -11.77511 c -0.48142,0 -0.94418,0.191378 -1.28405,0.531926 -0.34072,0.340633 -0.53228,0.802551 -0.53228,1.284302' />
      <path d='m 117.83348,12.611343 v 15.395286 c 0,0.481663 0.19154,0.943669 0.53226,1.284217 0.34071,0.340633 0.80264,0.532011 1.28405,0.532011 h 11.77173 V 26.19048 h -9.95881 v -4.071325 h 8.14927 v -3.632373 h -8.1552 v -4.062257 h 9.95881 v -3.632376 h -11.77173 c -0.48141,0 -0.94334,0.191378 -1.28405,0.531926 -0.34072,0.340633 -0.53227,0.802551 -0.53227,1.284302' />
      <path d='m 17.512167,18.498901 v 5.448522 h 16.751291 v 1.177509 c -3.65e-4,1.024019 -0.267911,2.030239 -0.775854,2.919329 -0.508028,0.889169 -1.239045,1.630444 -2.120926,2.150929 -2.13186,1.288114 -4.574179,1.971503 -7.064979,1.976586 -2.492925,0.0018 -4.937447,-0.687623 -7.061995,-1.991756 -0.879089,-0.52235 -1.607081,-1.264472 -2.112342,-2.153476 -0.505268,-0.889002 -0.77041,-1.894204 -0.769347,-2.916699 v -7.788456 c 3.56e-4,-1.024019 0.267925,-2.030239 0.775916,-2.919325 0.507997,-0.889173 1.239006,-1.630446 2.120902,-2.150933 2.12934,-1.293117 4.570729,-1.98167 7.061948,-1.991757 2.493933,-0.0021 4.939564,0.687198 7.064987,1.991757 0.649479,0.385215 1.215813,0.895529 1.66638,1.501449 0.45056,0.605834 0.776188,1.295236 0.958077,2.028036 h 5.524206 C 39.301,14.097703 38.6911,12.489209 37.747004,11.077266 36.80291,9.665321 35.549456,8.487038 34.081909,7.6319694 31.881995,6.336938 29.453657,5.4768037 26.929125,5.0983766 V 0.3883816 H 21.480517 V 5.0075682 C 18.983785,5.4353578 16.588744,6.3253925 14.418554,7.6319694 12.732454,8.623459 11.33621,10.040195 10.369417,11.74065 9.4026239,13.441017 8.8991863,15.365398 8.9094299,17.321389 v 7.788456 c -0.00777,1.956759 0.4986847,3.881303 1.4681141,5.581164 0.969436,1.699777 2.368093,3.115365 4.056139,4.105142 2.201108,1.292442 4.628927,2.152458 7.152776,2.533603 V 42.0398 H 27.0199 v -4.616218 c 2.523849,-0.377929 4.951846,-1.235913 7.152784,-2.527504 1.688674,-0.989097 3.087826,-2.404517 4.057341,-4.104549 0.969522,-1.699945 1.475425,-3.624831 1.466957,-5.58184 v -6.710788 z' />
    </svg>
  );
}

export function SearchIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg aria-hidden='true' viewBox='0 0 20 20' {...props}>
      <path d='M16.293 17.707a1 1 0 0 0 1.414-1.414l-1.414 1.414ZM9 14a5 5 0 0 1-5-5H2a7 7 0 0 0 7 7v-2ZM4 9a5 5 0 0 1 5-5V2a7 7 0 0 0-7 7h2Zm5-5a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7v2Zm8.707 12.293-3.757-3.757-1.414 1.414 3.757 3.757 1.414-1.414ZM14 9a4.98 4.98 0 0 1-1.464 3.536l1.414 1.414A6.98 6.98 0 0 0 16 9h-2Zm-1.464 3.536A4.98 4.98 0 0 1 9 14v2a6.98 6.98 0 0 0 4.95-2.05l-1.414-1.414Z' />
    </svg>
  );
}

export function LightIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg aria-hidden='true' viewBox='0 0 16 16' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 1a1 1 0 0 1 2 0v1a1 1 0 1 1-2 0V1Zm4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm2.657-5.657a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707a1 1 0 0 0 0-1.414Zm-1.415 11.313-.707-.707a1 1 0 0 1 1.415-1.415l.707.708a1 1 0 0 1-1.415 1.414ZM16 7.999a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2h1a1 1 0 0 0 1-1ZM7 14a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1Zm-2.536-2.464a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707a1 1 0 0 0 0-1.414Zm0-8.486A1 1 0 0 1 3.05 4.464l-.707-.707a1 1 0 0 1 1.414-1.414l.707.707ZM3 8a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1Z'
      />
    </svg>
  );
}

export function DarkIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg aria-hidden='true' viewBox='0 0 16 16' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.23 3.333C7.757 2.905 7.68 2 7 2a6 6 0 1 0 0 12c.68 0 .758-.905.23-1.332A5.989 5.989 0 0 1 5 8c0-1.885.87-3.568 2.23-4.668ZM12 5a1 1 0 0 1 1 1 1 1 0 0 0 1 1 1 1 0 1 1 0 2 1 1 0 0 0-1 1 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 1 1 0-2 1 1 0 0 0 1-1 1 1 0 0 1 1-1Z'
      />
    </svg>
  );
}

export function SystemIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg aria-hidden='true' viewBox='0 0 16 16' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 4a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-1.5l.31 1.242c.084.333.36.573.63.808.091.08.182.158.264.24A1 1 0 0 1 11 15H5a1 1 0 0 1-.704-1.71c.082-.082.173-.16.264-.24.27-.235.546-.475.63-.808L5.5 11H4a3 3 0 0 1-3-3V4Zm3-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Z'
      />
    </svg>
  );
}

export function GitHubIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg aria-hidden='true' viewBox='0 0 16 16' {...props}>
      <path d='M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.53 5.47 15.59C5.87 15.66 6.02 15.42 6.02 15.21C6.02 15.02 6.01 14.39 6.01 13.72C4 14.09 3.48 13.23 3.32 12.78C3.23 12.55 2.84 11.84 2.5 11.65C2.22 11.5 1.82 11.13 2.49 11.12C3.12 11.11 3.57 11.7 3.72 11.94C4.44 13.15 5.59 12.81 6.05 12.6C6.12 12.08 6.33 11.73 6.56 11.53C4.78 11.33 2.92 10.64 2.92 7.58C2.92 6.71 3.23 5.99 3.74 5.43C3.66 5.23 3.38 4.41 3.82 3.31C3.82 3.31 4.49 3.1 6.02 4.13C6.66 3.95 7.34 3.86 8.02 3.86C8.7 3.86 9.38 3.95 10.02 4.13C11.55 3.09 12.22 3.31 12.22 3.31C12.66 4.41 12.38 5.23 12.3 5.43C12.81 5.99 13.12 6.7 13.12 7.58C13.12 10.65 11.25 11.33 9.47 11.53C9.76 11.78 10.01 12.26 10.01 13.01C10.01 14.08 10 14.94 10 15.21C10 15.42 10.15 15.67 10.55 15.59C13.71 14.53 16 11.53 16 8C16 3.58 12.42 0 8 0Z' />
    </svg>
  );
}

export function InfoIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 16 16' aria-hidden='true' {...props}>
      <circle cx='8' cy='8' r='8' strokeWidth='0' />
      <path
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
        d='M6.75 7.75h1.5v3.5'
      />
      <circle cx='8' cy='4' r='.5' fill='none' />
    </svg>
  );
}

export function TwitterIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 20 20' aria-hidden='true' {...props}>
      <path d='M16.712 6.652c.01.146.01.29.01.436 0 4.449-3.267 9.579-9.242 9.579v-.003a8.963 8.963 0 0 1-4.98-1.509 6.379 6.379 0 0 0 4.807-1.396c-1.39-.027-2.608-.966-3.035-2.337.487.097.99.077 1.467-.059-1.514-.316-2.606-1.696-2.606-3.3v-.041c.45.26.956.404 1.475.42C3.18 7.454 2.74 5.486 3.602 3.947c1.65 2.104 4.083 3.382 6.695 3.517a3.446 3.446 0 0 1 .94-3.217 3.172 3.172 0 0 1 4.596.148 6.38 6.38 0 0 0 2.063-.817 3.357 3.357 0 0 1-1.428 1.861 6.283 6.283 0 0 0 1.865-.53 6.735 6.735 0 0 1-1.62 1.744Z' />
    </svg>
  );
}

export function TwitterIconOld(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width='19'
      height='15'
      viewBox='0 0 19 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M17.0548 3.63409C17.0664 3.79247 17.0664 3.95084 17.0664 4.11068C17.0664 8.98094 13.1452 14.5978 5.97518 14.5978V14.5949C3.85712 14.5978 1.78306 14.0242 0 12.9425C0.307983 12.9776 0.61751 12.9951 0.927808 12.9958C2.68308 12.9973 4.38818 12.4404 5.76908 11.415C4.10104 11.385 2.63831 10.3567 2.12732 8.85541C2.71164 8.96196 3.31371 8.94007 3.88722 8.79191C2.06866 8.4445 0.760309 6.93372 0.760309 5.17917C0.760309 5.16312 0.760309 5.14779 0.760309 5.13246C1.30217 5.41783 1.90888 5.57621 2.52947 5.59373C0.816657 4.51137 0.288686 2.35686 1.32301 0.672379C3.30213 2.97504 6.22218 4.37489 9.35682 4.52304C9.04266 3.24289 9.47183 1.90144 10.4845 1.00154C12.0546 -0.393925 14.5238 -0.3224 15.9997 1.16138C16.8727 0.99862 17.7094 0.695734 18.4751 0.266585C18.1841 1.11977 17.5751 1.84451 16.7615 2.30504C17.5342 2.21892 18.2891 2.02332 19 1.72482C18.4767 2.46634 17.8175 3.11225 17.0548 3.63409Z'
        fill='white'
      />
    </svg>
  );
}

export function TwitterIconNew(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      aria-hidden='true'
      {...props}
    >
      <g clipPath='url(#clip0_4734_1193)'>
        <path
          d='M10.9256 8.12177L17.4824 0.5H15.9286L10.2354 7.11788L5.68815 0.5H0.443481L7.31975 10.5074L0.443481 18.5H1.99733L8.00958 11.5113L12.8118 18.5H18.0564L10.9252 8.12177H10.9256ZM8.79738 10.5956L8.10067 9.59906L2.5572 1.66971H4.94381L9.41746 8.06895L10.1142 9.06546L15.9294 17.3835H13.5428L8.79738 10.596V10.5956Z'
          fill='#F4F4F4'
        />
      </g>
      <defs>
        <clipPath id='clip0_4734_1193'>
          <rect width='18' height='18' fill='white' transform='translate(0.25 0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RedditIconOld(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width='32'
      height='30'
      viewBox='0 0 32 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M31.6667 15.2657C31.6667 13.2283 30.1084 11.5748 28.1883 11.5748C27.2422 11.5748 26.4074 11.9587 25.7953 12.6083C23.43 10.8071 20.1465 9.62599 16.529 9.47835L18.1151 1.59449L23.263 2.74606C23.3187 4.13386 24.4039 5.25591 25.7396 5.25591C27.1031 5.25591 28.2162 4.07481 28.2162 2.62796C28.2162 1.1811 27.1031 0 25.7396 0C24.7657 0 23.9309 0.590551 23.5413 1.47638L17.7812 0.177167C17.6142 0.14764 17.4473 0.177166 17.3081 0.265748C17.169 0.354331 17.0855 0.501969 17.0299 0.679135L15.2768 9.47835C11.5759 9.59646 8.2645 10.748 5.87141 12.6083C5.25923 11.9882 4.3966 11.5748 3.47832 11.5748C1.55829 11.5748 0 13.2283 0 15.2657C0 16.7717 0.834798 18.0413 2.05917 18.6319C2.00352 18.9862 1.97569 19.3701 1.97569 19.7539C1.97569 25.4232 8.18102 30 15.8612 30C23.5413 30 29.7466 25.4232 29.7466 19.7539C29.7466 19.3701 29.7188 19.0157 29.6632 18.6614C30.804 18.0709 31.6667 16.7717 31.6667 15.2657ZM7.87493 17.8937C7.87493 16.4469 8.98799 15.2657 10.3515 15.2657C11.715 15.2657 12.8281 16.4469 12.8281 17.8937C12.8281 19.3406 11.715 20.5217 10.3515 20.5217C8.98799 20.5217 7.87493 19.3406 7.87493 17.8937ZM21.7047 24.8327C20.0073 26.6339 16.7794 26.752 15.8333 26.752C14.8872 26.752 11.6315 26.6043 9.96192 24.8327C9.71148 24.5669 9.71148 24.124 9.96192 23.8583C10.2124 23.5925 10.6298 23.5925 10.8802 23.8583C11.9376 24.9803 14.2194 25.3937 15.8612 25.3937C17.5029 25.3937 19.7569 24.9803 20.8421 23.8583C21.0926 23.5925 21.51 23.5925 21.7604 23.8583C21.9552 24.1535 21.9552 24.5669 21.7047 24.8327ZM21.2595 20.5217C19.896 20.5217 18.783 19.3406 18.783 17.8937C18.783 16.4469 19.896 15.2657 21.2595 15.2657C22.623 15.2657 23.7361 16.4469 23.7361 17.8937C23.7361 19.3406 22.623 20.5217 21.2595 20.5217Z'
        fill='white'
      />
    </svg>
  );
}

export function RedditIconNew(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      aria-hidden='true'
      {...props}
    >
      <ellipse cx='12.2499' cy='15.5' rx='9' ry='6.5' stroke='#F4F4F4' strokeWidth='1.51875' />
      <path
        d='M15.7499 16.7803C14.7648 17.548 13.5561 18.0002 12.2499 18.0002C10.9437 18.0002 9.735 17.548 8.74988 16.7803'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
      />
      <circle cx='19.25' cy='3.99805' r='2' stroke='#F4F4F4' strokeWidth='1.51875' />
      <path
        d='M18.2499 10.0694C18.6186 9.43053 19.3132 9 20.1094 9C21.2916 9 22.2499 9.94921 22.2499 11.1201C22.2499 11.937 21.7835 12.6459 21.1001 13'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
      />
      <path
        d='M6.25 10.0694C5.88125 9.43053 5.18663 9 4.39048 9C3.20833 9 2.25 9.94921 2.25 11.1201C2.25 11.937 2.7164 12.6459 3.39981 13'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
      />
      <path
        d='M17.25 4C14.893 4 13.7145 4 12.9822 4.73223C12.25 5.46447 12.25 6.64298 12.25 9'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.25801 13L9.24902 13'
        stroke='#F4F4F4'
        strokeWidth='2.025'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.258 13L15.249 13'
        stroke='#F4F4F4'
        strokeWidth='2.025'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function DiscordIconOld(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width='19'
      height='15'
      viewBox='0 0 19 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M16.0843 1.21395C14.8733 0.652067 13.5747 0.238094 12.2169 0.000994602C12.1922 -0.00358135 12.1675 0.0078542 12.1548 0.0307258C11.9877 0.331102 11.8027 0.722966 11.6732 1.03097C10.2128 0.809885 8.75994 0.809885 7.3295 1.03097C7.19993 0.71612 7.00822 0.331102 6.84046 0.0307258C6.82772 0.00861731 6.80302 -0.00281824 6.77829 0.000994602C5.42126 0.237337 4.12265 0.65131 2.91091 1.21395C2.90042 1.21853 2.89143 1.22616 2.88546 1.23606C0.422268 4.95727 -0.252502 8.58702 0.0785176 12.1718C0.0800154 12.1893 0.0897511 12.2061 0.103232 12.2167C1.72837 13.4236 3.3026 14.1563 4.8476 14.6419C4.87232 14.6495 4.89852 14.6404 4.91426 14.6198C5.27973 14.1151 5.60551 13.583 5.88484 13.0233C5.90132 12.9906 5.88558 12.9517 5.85189 12.9387C5.33515 12.7405 4.8431 12.4988 4.36979 12.2244C4.33235 12.2023 4.32935 12.1481 4.36379 12.1222C4.46339 12.0467 4.56302 11.9682 4.65813 11.8889C4.67534 11.8744 4.69932 11.8714 4.71955 11.8805C7.82902 13.3161 11.1954 13.3161 14.2682 11.8805C14.2884 11.8706 14.3124 11.8737 14.3303 11.8881C14.4255 11.9674 14.5251 12.0467 14.6254 12.1222C14.6599 12.1481 14.6576 12.2023 14.6202 12.2244C14.1469 12.5042 13.6548 12.7405 13.1373 12.938C13.1036 12.9509 13.0886 12.9906 13.1051 13.0233C13.3905 13.5822 13.7162 14.1143 14.075 14.619C14.0899 14.6404 14.1169 14.6495 14.1416 14.6419C15.6941 14.1563 17.2683 13.4236 18.8935 12.2167C18.9077 12.2061 18.9167 12.1901 18.9182 12.1725C19.3144 8.02817 18.2546 4.42819 16.109 1.23682C16.1038 1.22616 16.0948 1.21853 16.0843 1.21395ZM6.34918 9.98903C5.41302 9.98903 4.64165 9.11993 4.64165 8.05258C4.64165 6.98522 5.39806 6.11612 6.34918 6.11612C7.30777 6.11612 8.07168 6.99285 8.0567 8.05258C8.0567 9.11993 7.30028 9.98903 6.34918 9.98903ZM12.6625 9.98903C11.7264 9.98903 10.955 9.11993 10.955 8.05258C10.955 6.98522 11.7114 6.11612 12.6625 6.11612C13.6211 6.11612 14.385 6.99285 14.37 8.05258C14.37 9.11993 13.6211 9.98903 12.6625 9.98903Z'
        fill='white'
      />
    </svg>
  );
}

export function DiscordIconNew(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M7.24988 7.00098C11.1388 5.66764 13.361 5.66764 17.2499 7.00098'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.24976 17.001C10.7498 18.3343 13.7498 18.3343 17.2498 17.001'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.10703 17.626C9.10703 18.751 6.98605 21.001 6.44206 21.001C4.80894 21.001 3.35868 19.1256 2.63298 17.626C1.90728 15.7506 2.08899 11.0639 4.26495 4.68848C5.85121 3.5466 7.44433 3.18098 9.10716 3.00098L10.25 6.00098'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.3928 17.626C15.3928 18.751 17.5138 21.001 18.0578 21.001C19.6909 21.001 21.1412 19.1256 21.8669 17.626C22.5926 15.7506 22.4109 11.0639 20.2349 4.68848C18.6487 3.5466 17.0555 3.18098 15.3927 3.00098L14.2499 6.00098'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.75997 12.001H7.74988M16.7499 12.001H16.7398'
        stroke='#F4F4F4'
        strokeWidth='2.025'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function TelegramIconOld(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width='19'
      height='16'
      viewBox='0 0 19 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M7.44337 10.5168L14.4847 15.7191C15.2883 16.1624 15.868 15.9328 16.0682 14.9731L18.9344 1.46665C19.2278 0.290187 18.486 -0.243589 17.7172 0.105419L0.887056 6.59505C-0.261743 7.05588 -0.2549 7.69682 0.677681 7.98234L4.99667 9.33047L14.9956 3.02226C15.4676 2.73601 15.901 2.88977 15.5454 3.20543'
        fill='url(#paint0_linear_1870_581)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1870_581'
          x1='12.54'
          y1='6.96408'
          x2='15.2668'
          y2='13.1768'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EFF7FC' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function TelegramIconNew(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M12.2354 15.4093L15.4768 19.0945C16.6777 20.4599 17.2782 21.1426 17.9067 20.9764C18.5352 20.8102 18.7508 19.9117 19.1818 18.1148L21.5729 8.14688C22.2368 5.3793 22.5687 3.99551 21.8308 3.31298C21.093 2.63044 19.814 3.13823 17.2561 4.15379L5.38876 8.86546C3.34293 9.67772 2.32001 10.0838 2.25507 10.7818C2.24842 10.8532 2.24831 10.9251 2.25474 10.9965C2.31754 11.6947 3.33922 12.1042 5.38255 12.9233C6.30838 13.2944 6.7713 13.48 7.10321 13.8353C7.14052 13.8753 7.1764 13.9167 7.21078 13.9594C7.51659 14.3393 7.64709 14.838 7.90809 15.8354L8.39653 17.702C8.6505 18.6725 8.77749 19.1578 9.11008 19.2239C9.44267 19.2901 9.73225 18.8877 10.3114 18.0829L12.2354 15.4093ZM12.2354 15.4093L11.9176 15.0781C11.5559 14.7011 11.3751 14.5126 11.3751 14.2784C11.3751 14.0442 11.5559 13.8558 11.9176 13.4788L15.4906 9.75507'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function EmailIconNew(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M17.25 20.5H7.25C4.25 20.5 2.25 19 2.25 15.5V8.5C2.25 5 4.25 3.5 7.25 3.5H17.25C20.25 3.5 22.25 5 22.25 8.5V15.5C22.25 19 20.25 20.5 17.25 20.5Z'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.2504 9.00098L14.1204 11.501C13.0904 12.321 11.4004 12.321 10.3704 11.501L7.25037 9.00098'
        stroke='#F4F4F4'
        strokeWidth='1.51875'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function YoutubeIconNew(props: React.SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M22.7504 8.30996C22.5504 7.54996 21.9404 6.93996 21.1804 6.73996C19.8304 6.39996 12.7504 6.39996 12.7504 6.39996C12.7504 6.39996 5.67037 6.39996 4.32037 6.73996C3.56037 6.93996 2.95037 7.54996 2.75037 8.30996C2.41037 9.65996 2.41037 12.9 2.41037 12.9C2.41037 12.9 2.41037 16.14 2.75037 17.49C2.95037 18.25 3.56037 18.86 4.32037 19.06C5.67037 19.4 12.7504 19.4 12.7504 19.4C12.7504 19.4 19.8304 19.4 21.1804 19.06C21.9404 18.86 22.5504 18.25 22.7504 17.49C23.0904 16.14 23.0904 12.9 23.0904 12.9C23.0904 12.9 23.0904 9.65996 22.7504 8.30996Z'
        stroke='#F4F4F4'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.4004 15.6001L16.2004 12.9001L10.4004 10.2001V15.6001Z'
        stroke='#F4F4F4'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function GitHubIcon2(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 20 20' aria-hidden='true' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 1.667c-4.605 0-8.334 3.823-8.334 8.544 0 3.78 2.385 6.974 5.698 8.106.417.075.573-.182.573-.406 0-.203-.011-.875-.011-1.592-2.093.397-2.635-.522-2.802-1.002-.094-.246-.5-1.005-.854-1.207-.291-.16-.708-.556-.01-.567.656-.01 1.124.62 1.281.876.75 1.292 1.948.93 2.427.705.073-.555.291-.93.531-1.143-1.854-.213-3.791-.95-3.791-4.218 0-.929.322-1.698.854-2.296-.083-.214-.375-1.09.083-2.265 0 0 .698-.224 2.292.876a7.576 7.576 0 0 1 2.083-.288c.709 0 1.417.096 2.084.288 1.593-1.11 2.291-.875 2.291-.875.459 1.174.167 2.05.084 2.263.53.599.854 1.357.854 2.297 0 3.278-1.948 4.005-3.802 4.219.302.266.563.78.563 1.58 0 1.143-.011 2.061-.011 2.35 0 .224.156.491.573.405a8.365 8.365 0 0 0 4.11-3.116 8.707 8.707 0 0 0 1.567-4.99c0-4.721-3.73-8.545-8.334-8.545Z'
      />
    </svg>
  );
}

export function DiscordIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 20 20' aria-hidden='true' {...props}>
      <path d='M16.238 4.515a14.842 14.842 0 0 0-3.664-1.136.055.055 0 0 0-.059.027 10.35 10.35 0 0 0-.456.938 13.702 13.702 0 0 0-4.115 0 9.479 9.479 0 0 0-.464-.938.058.058 0 0 0-.058-.027c-1.266.218-2.497.6-3.664 1.136a.052.052 0 0 0-.024.02C1.4 8.023.76 11.424 1.074 14.782a.062.062 0 0 0 .024.042 14.923 14.923 0 0 0 4.494 2.272.058.058 0 0 0 .064-.02c.346-.473.654-.972.92-1.496a.057.057 0 0 0-.032-.08 9.83 9.83 0 0 1-1.404-.669.058.058 0 0 1-.029-.046.058.058 0 0 1 .023-.05c.094-.07.189-.144.279-.218a.056.056 0 0 1 .058-.008c2.946 1.345 6.135 1.345 9.046 0a.056.056 0 0 1 .059.007c.09.074.184.149.28.22a.058.058 0 0 1 .023.049.059.059 0 0 1-.028.046 9.224 9.224 0 0 1-1.405.669.058.058 0 0 0-.033.033.056.056 0 0 0 .002.047c.27.523.58 1.022.92 1.495a.056.056 0 0 0 .062.021 14.878 14.878 0 0 0 4.502-2.272.055.055 0 0 0 .016-.018.056.056 0 0 0 .008-.023c.375-3.883-.63-7.256-2.662-10.246a.046.046 0 0 0-.023-.021Zm-9.223 8.221c-.887 0-1.618-.814-1.618-1.814s.717-1.814 1.618-1.814c.908 0 1.632.821 1.618 1.814 0 1-.717 1.814-1.618 1.814Zm5.981 0c-.887 0-1.618-.814-1.618-1.814s.717-1.814 1.618-1.814c.908 0 1.632.821 1.618 1.814 0 1-.71 1.814-1.618 1.814Z' />
    </svg>
  );
}

export function CheckIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 20 20' aria-hidden='true' {...props}>
      <circle cx='10' cy='10' r='10' strokeWidth='0' />
      <path
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
        d='m6.75 10.813 2.438 2.437c1.218-4.469 4.062-6.5 4.062-6.5'
      />
    </svg>
  );
}

export function OpenNewTabIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      focusable='false'
      x='0px'
      y='0px'
      viewBox='0 0 100 100'
      width='15'
      height='15'
      className={
        props.className
          ? props.className
          : 'ml-1 h-4 w-4 fill-zinc-700 transition group-hover:fill-zinc-900 dark:group-hover:fill-zinc-500'
      }
    >
      <path
        fill='currentColor'
        d='M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z'
      ></path>{' '}
      <polygon
        fill='currentColor'
        points='45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9'
      ></polygon>
    </svg>
  );
}

export function ArrowIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 20 20' fill='none' aria-hidden='true' {...props}>
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='m11.5 6.5 3 3.5m0 0-3 3.5m3-3.5h-9'
      />
    </svg>
  );
}

export const ArrowIconWithDir = ({ direction }: { direction: 'left' | 'right' }) => {
  return (
    <ArrowIcon
      className={clsx(
        'mt-0.5 h-5 w-5',
        direction === 'left' && '-ml-1 rotate-180',
        direction === 'right' && '-mr-1',
      )}
    />
  );
};

export const AnchorIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 20 20' fill='none' strokeLinecap='round' aria-hidden='true' {...props}>
      <path d='m6.5 11.5-.964-.964a3.535 3.535 0 1 1 5-5l.964.964m2 2 .964.964a3.536 3.536 0 0 1-5 5L8.5 13.5m0-5 3 3' />
    </svg>
  );
};

export const Copy = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      className='h-5 w-5 text-gray-500'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      strokeWidth='2'
      stroke='currentColor'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      {' '}
      <path stroke='none' d='M0 0h24v24H0z' /> <rect x='8' y='8' width='12' height='12' rx='2' />{' '}
      <path d='M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2' />
    </svg>
  );
};

export const LoadingIcon = (props: SVGAttributes<SVGSVGElement>) => {
  const id = nanoid(12);
  return (
    <svg viewBox='0 0 20 20' fill='none' aria-hidden='true' {...props}>
      <circle cx='10' cy='10' r='5.5' strokeLinejoin='round' />
      <path
        stroke={`url(#${id})`}
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M15.5 10a5.5 5.5 0 1 0-5.5 5.5'
      />
      <defs>
        <linearGradient id={id} x1='13' x2='9.5' y1='9' y2='15' gradientUnits='userSpaceOnUse'>
          <stop stopColor='currentColor' />
          <stop offset='1' stopColor='currentColor' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const AppleIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 22 27' fill='none' {...props}>
      <path
        d='M22 19.3354C21.3991 20.6725 21.1117 21.2689 20.3367 22.4509C19.2568 24.1003 17.7328 26.1562 15.8474 26.1736C14.171 26.1889 13.7399 25.0791 11.4648 25.0922C9.18969 25.1053 8.71508 26.1933 7.03868 26.178C5.15327 26.1605 3.70983 24.3057 2.62996 22.654C-0.391911 18.0399 -0.70542 12.624 1.15604 9.74667C2.47974 7.69958 4.56762 6.50235 6.5314 6.50235C8.53002 6.50235 9.78841 7.60345 11.4409 7.60345C13.0454 7.60345 14.023 6.50235 16.3329 6.50235C18.0811 6.50235 19.9317 7.45708 21.2511 9.10873C16.9294 11.4835 17.6327 17.6794 22 19.3354Z'
        fill='#13141A'
      />
      <path
        d='M14.5741 4.66283C15.4145 3.58139 16.0524 2.05208 15.8194 0.492188C14.4478 0.586131 12.8432 1.46221 11.9049 2.60482C11.0536 3.64257 10.3526 5.17843 10.6247 6.67278C12.1248 6.71866 13.6749 5.82074 14.5741 4.66283Z'
        fill='#13141A'
      />
    </svg>
  );
};

export const ChromeIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 1024 1024'
      version='1.1'
      p-id='2756'
      width='24'
      height='24'
      {...props}
    >
      <path
        d='M258.016 447.008L112 192.992Q183.008 102.976 288 51.488T512 0q138.016 0 255.488 68t185.504 183.008H534.976q-11.008-0.992-23.008-0.992-90.016 0-160.992 55.488t-92.992 141.504z m436.992-122.016h294.016q35.008 90.016 35.008 187.008 0 103.008-40 197.504t-107.488 163.008-161.504 109.504-196.992 42.016l208.992-363.008q47.008-67.008 47.008-148.992 0-110.016-79.008-187.008zM326.016 512q0-76.992 54.496-131.488T512 326.016t131.488 54.496T697.984 512t-54.496 131.488T512 697.984t-131.488-54.496T326.016 512z m256 252.992l-146.016 252.992q-122.016-18.016-222.016-88.992t-156.992-180.992T0 512q0-135.008 66.016-251.008l208.992 362.016q32 68 96 109.504T512 774.016q36 0 70.016-8.992z'
        p-id='2757'
        fill='#ffffff'
      />
    </svg>
  );
};

export const ChromeColoredIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      width='100'
      height='100'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#4caf50'
        d='M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z'
      ></path>
      <path
        fill='#ffc107'
        d='M24,4v20l8,4l-8.843,16c0.317,0,0.526,0,0.843,0c11.053,0,20-8.947,20-20S35.053,4,24,4z'
      ></path>
      <path
        fill='#4caf50'
        d='M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z'
      ></path>
      <path
        fill='#ffc107'
        d='M24,4v20l8,4l-8.843,16c0.317,0,0.526,0,0.843,0c11.053,0,20-8.947,20-20S35.053,4,24,4z'
      ></path>
      <path
        fill='#f44336'
        d='M41.84,15H24v13l-3-1L7.16,13.26H7.14C10.68,7.69,16.91,4,24,4C31.8,4,38.55,8.48,41.84,15z'
      ></path>
      <path fill='#dd2c00' d='M7.158,13.264l8.843,14.862L21,27L7.158,13.264z'></path>
      <path fill='#558b2f' d='M23.157,44l8.934-16.059L28,25L23.157,44z'></path>
      <path fill='#f9a825' d='M41.865,15H24l-1.579,4.58L41.865,15z'></path>
      <path
        fill='#fff'
        d='M33,24c0,4.969-4.031,9-9,9s-9-4.031-9-9s4.031-9,9-9S33,19.031,33,24z'
      ></path>
      <path
        fill='#2196f3'
        d='M31,24c0,3.867-3.133,7-7,7s-7-3.133-7-7s3.133-7,7-7S31,20.133,31,24z'
      ></path>
    </svg>
  );
};

export const WindowsIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' {...props}>
      <path
        d='M4.21875 6.91405L12.3047 5.83594V13.3828H4.21875V6.91405Z'
        fill='black'
        stroke='black'
        strokeWidth='1.66667'
        strokeLinejoin='round'
      />
      <path
        d='M15.5361 5.5279L25.7783 4.21875V13.3828H15.5361V5.5279Z'
        fill='black'
        stroke='black'
        strokeWidth='1.66667'
        strokeLinejoin='round'
      />
      <path
        d='M15.5361 17.1445L25.7783 17.3841V25.7695L15.5361 24.0924V17.1445Z'
        fill='black'
        stroke='black'
        strokeWidth='1.66667'
        strokeLinejoin='round'
      />
      <path
        d='M4.21875 16.6172L12.3047 16.8119V23.625L4.21875 22.2624V16.6172Z'
        fill='black'
        stroke='black'
        strokeWidth='1.66667'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const GooglePlayIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg aria-label='Google Play' role='img' viewBox='0 0 512 512' {...props}>
      <rect width='512' height='512' rx='15%' fill='#fff' />
      <clipPath id='a'>
        <path d='M465 239L169 69c-15-9-35 2-35 20v334c0 18 20 29 35 20l296-171c13-7 13-25 0-33z' />
      </clipPath>
      <g clipPath='url(#a)' transform='translate(-10 17) scale(.93324)'>
        <path fill='#0e7' d='M20 53h400v355' />
        <path fill='#0df' d='M512 444H98V30' />
        <path fill='#f34' d='M399 181v322H76' />
        <path fill='#fd0' d='M324 256l180 180V76' />
      </g>
    </svg>
  );
};

export const LinuxIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      fill='#000000'
      height='800px'
      width='800px'
      version='1.1'
      id='Layer_1'
      viewBox='0 0 304.998 304.998'
      {...props}
    >
      <g id='XMLID_91_'>
        <path
          id='XMLID_92_'
          d='M274.659,244.888c-8.944-3.663-12.77-8.524-12.4-15.777c0.381-8.466-4.422-14.667-6.703-17.117
		c1.378-5.264,5.405-23.474,0.004-39.291c-5.804-16.93-23.524-42.787-41.808-68.204c-7.485-10.438-7.839-21.784-8.248-34.922
		c-0.392-12.531-0.834-26.735-7.822-42.525C190.084,9.859,174.838,0,155.851,0c-11.295,0-22.889,3.53-31.811,9.684
		c-18.27,12.609-15.855,40.1-14.257,58.291c0.219,2.491,0.425,4.844,0.545,6.853c1.064,17.816,0.096,27.206-1.17,30.06
		c-0.819,1.865-4.851,7.173-9.118,12.793c-4.413,5.812-9.416,12.4-13.517,18.539c-4.893,7.387-8.843,18.678-12.663,29.597
		c-2.795,7.99-5.435,15.537-8.005,20.047c-4.871,8.676-3.659,16.766-2.647,20.505c-1.844,1.281-4.508,3.803-6.757,8.557
		c-2.718,5.8-8.233,8.917-19.701,11.122c-5.27,1.078-8.904,3.294-10.804,6.586c-2.765,4.791-1.259,10.811,0.115,14.925
		c2.03,6.048,0.765,9.876-1.535,16.826c-0.53,1.604-1.131,3.42-1.74,5.423c-0.959,3.161-0.613,6.035,1.026,8.542
		c4.331,6.621,16.969,8.956,29.979,10.492c7.768,0.922,16.27,4.029,24.493,7.035c8.057,2.944,16.388,5.989,23.961,6.913
		c1.151,0.145,2.291,0.218,3.39,0.218c11.434,0,16.6-7.587,18.238-10.704c4.107-0.838,18.272-3.522,32.871-3.882
		c14.576-0.416,28.679,2.462,32.674,3.357c1.256,2.404,4.567,7.895,9.845,10.724c2.901,1.586,6.938,2.495,11.073,2.495
		c0.001,0,0,0,0.001,0c4.416,0,12.817-1.044,19.466-8.039c6.632-7.028,23.202-16,35.302-22.551c2.7-1.462,5.226-2.83,7.441-4.065
		c6.797-3.768,10.506-9.152,10.175-14.771C282.445,250.905,279.356,246.811,274.659,244.888z M124.189,243.535
		c-0.846-5.96-8.513-11.871-17.392-18.715c-7.26-5.597-15.489-11.94-17.756-17.312c-4.685-11.082-0.992-30.568,5.447-40.602
		c3.182-5.024,5.781-12.643,8.295-20.011c2.714-7.956,5.521-16.182,8.66-19.783c4.971-5.622,9.565-16.561,10.379-25.182
		c4.655,4.444,11.876,10.083,18.547,10.083c1.027,0,2.024-0.134,2.977-0.403c4.564-1.318,11.277-5.197,17.769-8.947
		c5.597-3.234,12.499-7.222,15.096-7.585c4.453,6.394,30.328,63.655,32.972,82.044c2.092,14.55-0.118,26.578-1.229,31.289
		c-0.894-0.122-1.96-0.221-3.08-0.221c-7.207,0-9.115,3.934-9.612,6.283c-1.278,6.103-1.413,25.618-1.427,30.003
		c-2.606,3.311-15.785,18.903-34.706,21.706c-7.707,1.12-14.904,1.688-21.39,1.688c-5.544,0-9.082-0.428-10.551-0.651l-9.508-10.879
		C121.429,254.489,125.177,250.583,124.189,243.535z M136.254,64.149c-0.297,0.128-0.589,0.265-0.876,0.411
		c-0.029-0.644-0.096-1.297-0.199-1.952c-1.038-5.975-5-10.312-9.419-10.312c-0.327,0-0.656,0.025-1.017,0.08
		c-2.629,0.438-4.691,2.413-5.821,5.213c0.991-6.144,4.472-10.693,8.602-10.693c4.85,0,8.947,6.536,8.947,14.272
		C136.471,62.143,136.4,63.113,136.254,64.149z M173.94,68.756c0.444-1.414,0.684-2.944,0.684-4.532
		c0-7.014-4.45-12.509-10.131-12.509c-5.552,0-10.069,5.611-10.069,12.509c0,0.47,0.023,0.941,0.067,1.411
		c-0.294-0.113-0.581-0.223-0.861-0.329c-0.639-1.935-0.962-3.954-0.962-6.015c0-8.387,5.36-15.211,11.95-15.211
		c6.589,0,11.95,6.824,11.95,15.211C176.568,62.78,175.605,66.11,173.94,68.756z M169.081,85.08
		c-0.095,0.424-0.297,0.612-2.531,1.774c-1.128,0.587-2.532,1.318-4.289,2.388l-1.174,0.711c-4.718,2.86-15.765,9.559-18.764,9.952
		c-2.037,0.274-3.297-0.516-6.13-2.441c-0.639-0.435-1.319-0.897-2.044-1.362c-5.107-3.351-8.392-7.042-8.763-8.485
		c1.665-1.287,5.792-4.508,7.905-6.415c4.289-3.988,8.605-6.668,10.741-6.668c0.113,0,0.215,0.008,0.321,0.028
		c2.51,0.443,8.701,2.914,13.223,4.718c2.09,0.834,3.895,1.554,5.165,2.01C166.742,82.664,168.828,84.422,169.081,85.08z
		 M205.028,271.45c2.257-10.181,4.857-24.031,4.436-32.196c-0.097-1.855-0.261-3.874-0.42-5.826
		c-0.297-3.65-0.738-9.075-0.283-10.684c0.09-0.042,0.19-0.078,0.301-0.109c0.019,4.668,1.033,13.979,8.479,17.226
		c2.219,0.968,4.755,1.458,7.537,1.458c7.459,0,15.735-3.659,19.125-7.049c1.996-1.996,3.675-4.438,4.851-6.372
		c0.257,0.753,0.415,1.737,0.332,3.005c-0.443,6.885,2.903,16.019,9.271,19.385l0.927,0.487c2.268,1.19,8.292,4.353,8.389,5.853
		c-0.001,0.001-0.051,0.177-0.387,0.489c-1.509,1.379-6.82,4.091-11.956,6.714c-9.111,4.652-19.438,9.925-24.076,14.803
		c-6.53,6.872-13.916,11.488-18.376,11.488c-0.537,0-1.026-0.068-1.461-0.206C206.873,288.406,202.886,281.417,205.028,271.45z
		 M39.917,245.477c-0.494-2.312-0.884-4.137-0.465-5.905c0.304-1.31,6.771-2.714,9.533-3.313c3.883-0.843,7.899-1.714,10.525-3.308
		c3.551-2.151,5.474-6.118,7.17-9.618c1.228-2.531,2.496-5.148,4.005-6.007c0.085-0.05,0.215-0.108,0.463-0.108
		c2.827,0,8.759,5.943,12.177,11.262c0.867,1.341,2.473,4.028,4.331,7.139c5.557,9.298,13.166,22.033,17.14,26.301
		c3.581,3.837,9.378,11.214,7.952,17.541c-1.044,4.909-6.602,8.901-7.913,9.784c-0.476,0.108-1.065,0.163-1.758,0.163
		c-7.606,0-22.662-6.328-30.751-9.728l-1.197-0.503c-4.517-1.894-11.891-3.087-19.022-4.241c-5.674-0.919-13.444-2.176-14.732-3.312
		c-1.044-1.171,0.167-4.978,1.235-8.337c0.769-2.414,1.563-4.91,1.998-7.523C41.225,251.596,40.499,248.203,39.917,245.477z'
        />
      </g>
    </svg>
  );
};
